export interface GridDefinition {
  [key: string]: string;
}
export interface KngGrid {
  state: KngGridState;
}
export interface KngGridState {
  grid: GridDefinition[];
  displayedColumns: string[];
  totalArrayLength: number;
  isSortable?: boolean;
}

export interface KngGridPagerCard{
  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
   startPage: number;
   endPage: number;
  startIndex: number;
  endIndex: number;
}
export const actionButtons = {
	actionButton: {
		remove: 'remove',
		move: 'move'
	}
};
export const expActionButtons = {
	actionButton: {
		remove: 'remove',
		move: 'move'
	}
};
export interface TableActionButton {
  name: string;
  value?: string;
}
